import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../../../i18n/i18n'
import './cta-band.scss'

export function CtaBand() {
  const navigate = useNavigate()
  const { t } = useI18n()
  return (
    <section className="cta-band">
      <div className="cta-band__inner">
        <span className="cta-band__emoji" aria-hidden>🤝</span>
        <h2>{t('cta.title')}</h2>
        <p>{t('cta.text')}</p>
        <button className="btn btn-primary" onClick={() => navigate('/contato')}>
          {t('cta.button')}
        </button>
      </div>
    </section>
  )
}
